var $3135b03c5e7cb78f$exports = {};
$3135b03c5e7cb78f$exports = {
    "Empty": `\u{41F}\u{443}\u{441}\u{442}\u{43E}`
};


export {$3135b03c5e7cb78f$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
